export default __webpack_public_path__ + "static/media/30year.aa77b91d.svg";